const items = [
  {
    id: 1,
    item_code: '101',
    vendor_code: '1000',
    description: 'H beam 10',
    serialized: false,
  },
  {
    id: 2,
    item_code: '102',
    vendor_code: '1001',
    description: 'H beam 11',
    serialized: false,
  },
  {
    id: 3,
    item_code: '103',
    vendor_code: '1002',
    description: 'H beam 12',
    serialized: false,
  },
  {
    id: 4,
    item_code: '104',
    vendor_code: 'h100',
    description: 'receiver head h100',
    serialized: true,
  },
  {
    id: 5,
    item_code: '105',
    vendor_code: 'z100',
    description: 'receiver head z100',
    serialized: true,
  },
  {
    id: 6,
    item_code: '106',
    vendor_code: 'hq10',
    description: 'receiver head hq10',
    serialized: true,
  },
  {
    id: 7,
    item_code: '107',
    vendor_code: '1010',
    description: 'pole 2m',
    serialized: false,
  },
  {
    id: 8,
    item_code: '108',
    vendor_code: '1020',
    description: 'angle 1.5"',
    serialized: false,
  },
  {
    id: 9,
    item_code: '109',
    vendor_code: '1030',
    description: 'angle 2.5"',
    serialized: false,
  },
  {
    id: 10,
    item_code: '110',
    vendor_code: 'p110',
    description: 'processing unit',
    serialized: true,
  },
  {
    id: 11,
    item_code: '111',
    vendor_code: 'az12',
    description: 'ball bearing 20mm',
    serialized: false,
  },
  {
    id: 12,
    item_code: '112',
    vendor_code: 'az15',
    description: 'ball bearing 30mm',
    serialized: false,
  },
  {
    id: 13,
    item_code: '113',
    vendor_code: 'ق11',
    description: 'قطعة رقم 11',
    serialized: true,
  },
  {
    id: 14,
    item_code: '114',
    vendor_code: 'vlt32432',
    description: 'an example of a very long item desction vl455452 232323435 vvvvvv',
    serialized: false,
  },
];

const id = {
  items: (items[items.length -1] || {id: 0}).id,
};

const new_id = (table) => ++id[table];

export default {
  items,
  id,
  new_id,
}
